import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import FAprint from 'react-icons/lib/fa/print';

import * as actions from '../../actions/ticket';

import {API_URL} from '../../actions/_request';
import {api,API_UR} from '../../actions/_request';

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

        



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

   this.state = {     
      data:[]
          };

    

    }

    formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}

   

   

    render() {
      console.log("Lista tickets---->",this.props.lista);

     

        return(
            <div className="view">
            <div className="row justify-content-end">
                       
                          <div className="col-2  text-left" >
                               <label>Imprimir: </label>{' '}
                            <a target="_blank" href={`${API_UR}/api/imprimir/individual/${this.props.data.usuario_id}/${this.props.data.inicio}/${this.props.data.final}`} title="Imprimir ">
                              <FAprint size="30"/>
                            </a>
                          </div>
                          
                        </div>
            
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase"> Listado de Tickets</h1>
                        
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                       
                          <div className="col-5  text-left" >
                                 <h5 className=" ">Total de Ventas : { this.props.data.total_ventas} </h5>
                                <h5 className=" "> Utilidad de Ventas : {this.props.data.utilidad_ventas}</h5>
                                <h5 className=" "> Utilidad de Servicios : { this.props.data.Serv}</h5>
                                <h5 className=" "> Total de  Utilidades : { this.props.data.utilidad_total}</h5>
                          </div>
                          
                        </div>
                           
                            <ReactTable
                              data      = {this.props.lista}
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'fecha_finalizado',maxWidth:100},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},  
                                {Header: 'Subtotal', accessor: 'total',maxWidth:150 , style: { 'textAlign': 'center'}},                             
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={filterCaseInsensitive}
                              
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>                                           
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Costo Total</th>  
                                                  <th>Producción</th>                                                
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>  
                                                     <td>{this.formateo(item.subtotal)}</td> 
                                                     <td>{this.formateo(item.costo_total)}</td>
                                                     <td>{this.formateo(item.produccion)}</td>
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketTable)


// WEBPACK FOOTER //
// ./src/views/reportes/lista_tickets.js